"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GSTInputSchema = exports.GSTBreakdownSchema = void 0;
const zod_1 = require("zod");
exports.GSTBreakdownSchema = zod_1.z.object({
    totalIncGST: zod_1.z.number(),
    totalExGST: zod_1.z.number(),
    gstAmount: zod_1.z.number(),
});
exports.GSTInputSchema = zod_1.z.object({
    amount: zod_1.z.number(),
    gstRate: zod_1.z.number().optional(),
    isGSTRegistered: zod_1.z.boolean(),
    isInclusive: zod_1.z.boolean(),
});
